import * as cookies from 'lib/cookies';

import { getEnvValue } from './utils';

const appPort = getEnvValue('NEXT_PUBLIC_APP_PORT');
const appSchema = getEnvValue('NEXT_PUBLIC_APP_PROTOCOL');
const appHost = getEnvValue('NEXT_PUBLIC_APP_HOST');

// Omit default ports (443 for https, 80 for http) to avoid WalletConnect metadata URL mismatch
const isDefaultPort = (appPort === '443' && (appSchema === 'https' || !appSchema)) || (appPort === '80' && appSchema === 'http');

const baseUrl = [
  appSchema || 'https',
  '://',
  appHost,
  !isDefaultPort && appPort && ':' + appPort,
].filter(Boolean).join('');
const isDev = getEnvValue('NEXT_PUBLIC_APP_ENV') === 'development';
const isReview = getEnvValue('NEXT_PUBLIC_APP_ENV') === 'review';
const isPw = getEnvValue('NEXT_PUBLIC_APP_INSTANCE') === 'pw';
const spriteHash = getEnvValue('NEXT_PUBLIC_ICON_SPRITE_HASH');
const isPrivateMode = cookies.get(cookies.NAMES.APP_PROFILE) === 'private';

const app = Object.freeze({
  isDev,
  isReview,
  isPw,
  protocol: appSchema,
  host: appHost,
  port: appPort,
  baseUrl,
  useProxy: getEnvValue('NEXT_PUBLIC_USE_NEXT_JS_PROXY') === 'true',
  spriteHash,
  isPrivateMode,
});

export default app;
